import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { ApiValidationErrors, Nullable } from "store/types";

import { useModals } from "../../../hooks";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none"
};

export const PdfTaggerErrorModal: React.FC<{ data: Nullable<ApiValidationErrors> | undefined }> = ({ data }) => {
  const { closePdfTaggerErrorModal } = useModals();
  if (!data) return null;
  const errorValue = Object.entries(data);
  const errorKey = errorValue[0]?.[0];
  const errorMessages = errorValue[0]?.[1] || [];
  //can be changed later, depend on error key
  const title = errorKey === "value" || errorKey === "entity" ? "Incorrect value" : "Message";

  return (
    <Modal open={!!data} onClose={closePdfTaggerErrorModal}>
      <Box sx={style}>
        <Stack
          justifyContent="space-between"
          sx={{ minHeight: "205px", minWidth: "460px", backgroundColor: "#fff", padding: "30px", borderRadius: "8px" }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ borderBottom: "1px solid #DAE0E2" }}
          >
            <Stack direction="row" alignItems="center">
              <ErrorOutlineIcon sx={{ marginRight: "10px" }} />
              <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>{title}</Typography>
            </Stack>
            <IconButton onClick={closePdfTaggerErrorModal}>
              <CloseIcon />
            </IconButton>
          </Stack>
          {errorMessages.map((message: string, idx) => (
            <Typography key={idx} sx={{ fontSize: "16px" }}>
              {message}
            </Typography>
          ))}
          <Stack direction="row-reverse">
            <Button onClick={closePdfTaggerErrorModal} variant="outlined">
              Ok
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};
